import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Claim your handle",
    body: "Grab your BREELINK — breel.ink/you — in seconds. No credit card, no code, no wait.",
  },
  {
    n: "02",
    title: "Compose your world",
    body: "Drag in blocks for music, video, products, bookings and links. Arrange until it feels like you.",
  },
  {
    n: "03",
    title: "Theme it your way",
    body: "Pick light, dark or system. Fine-tune colors, type and motion — every surface stays consistent.",
  },
  {
    n: "04",
    title: "Ship & grow",
    body: "Share one link everywhere. Watch clicks, sales and fans grow with analytics built in.",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto"
    className="border-y border-line bg-surfaceAlt px-6 py-28 md:px-12 lg:px-24"
  >
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-inkMuted">How it works</p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-semibold tracking-tighter text-ink md:text-5xl lg:text-6xl">
          From handle to homepage in four moves
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-line bg-line md:grid-cols-2">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={(i % 2) * 0.1}>
            <div className="group relative h-full bg-bg p-8 md:p-12">
              <span className="font-display text-6xl font-semibold tracking-tighter text-inkMuted/40 md:text-7xl">
                {c.n}
              </span>
              <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-ink">{c.title}</h3>
              <p className="mt-3 max-w-sm text-sm leading-relaxed text-inkMuted md:text-base">{c.body}</p>
              <span className="mt-8 block h-[2px] w-10 bg-lime transition-all duration-300 group-hover:w-24" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
